const hitApi = async (played, duration, activeEpisode) => {

    const episodeId = activeEpisode.link.split("/").filter(Boolean).pop();
    const podcastId = activeEpisode.itunes.image
      .split("podcast/")[1]
      .split("/")[0]? activeEpisode.itunes.image
      .split("podcast/")[1]
      .split("/")[0] : '';
    const baseUrl = window.location.host.includes('.com') ? 'https://apis.hubhopper.com/v5/' : 'https://apis.hubhopper.co/stage/';
    const apiKey = window.location.host.includes('.com') ? '9s0pBnORiaaMMCPvl1vcL3HrOJLFQ38j4bqk8Aw3' : 'DdjDiUOzsC7nn0t95VTJi9CC29kb9o5A1yr6zTdk';
    const endpoint = `/analytics/podcasts/${podcastId}/episodes/${episodeId}/embedplayer/track`;
    const url = `${baseUrl}${endpoint}`;
    console.log(url);
  
    const requestBody = {
      playbackPosition: played * duration,
      totalDuration: duration,
    };
  
    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(requestBody),
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
      });
  
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
  
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error("Something went wrong");
    }
  };
  
  export default hitApi;
  